// Full-page layouts for the inner pages of a school site.
// Keep in sync with school-sites/utils/pageLayouts.ts (pageLayoutComponents,
// PAGE_LAYOUT_VARIANTS) and the LinkedWebsite.page_layouts JSON field.
//
// 'Default' means school-sites renders that page's built-in markup — the value
// every school has until they pick something else. It has no thumbnail because
// it isn't one of the gallery layouts; the picker renders it as a labelled tile.

export const PAGE_LAYOUT_PAGES = [
  { key: 'about', label: 'About' },
  { key: 'tuition', label: 'Tuition & Financing' },
  { key: 'locations', label: 'Locations' },
  { key: 'gallery', label: 'Gallery' },
  { key: 'faqs', label: 'FAQs' },
  { key: 'blogs', label: 'Blog' },
];

export const DEFAULT_PAGE_LAYOUT = 'Default';

export const PAGE_LAYOUT_OPTIONS = ['Default', 'Layout1', 'Layout2', 'Layout3', 'Layout4', 'Layout5', 'Layout6'];

export const PAGE_LAYOUT_LABELS = {
  Default: 'Current design',
  Layout1: 'Layout 1',
  Layout2: 'Layout 2',
  Layout3: 'Layout 3',
  Layout4: 'Layout 4',
  Layout5: 'Layout 5',
  Layout6: 'Layout 6',
};

/** Every page starts on its built-in markup so existing sites don't change. */
export function defaultPageLayouts() {
  return PAGE_LAYOUT_PAGES.reduce((acc, page) => ({ ...acc, [page.key]: DEFAULT_PAGE_LAYOUT }), {});
}

// Thumbnails captured per page from school-sites /preview/pages — regenerate with
// school-sites/scripts/capture-page-layouts.sh after changing a layout component.
export function pageLayoutImage(page, layout) {
  try {
    return require(`@/assets/images/pageLayouts/${String(page).toLowerCase()}_${String(layout).toLowerCase()}.png`);
  } catch (e) {
    return null;
  }
}
